/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-useless-constructor */
import BaseObserver from './baseObserver';

export default class ConnectorModelObserver extends BaseObserver {
    getObserveData(): Record<string, any> {
        const { operationFrame, operatingGraphicInfo, previewChange } = this.model;
        return {
            selected: this.model.selected,
            operationFrame,
            operatingGraphicInfo,
            previewChange,
        };
    }
}
